import objectPath from 'object-path'
import { getDataValue } from '../Render'
import { getCheckValue } from 'designer/component/action/Data'

export const genRefId = '@genId'

export const getRowId = (rowData, uischema) => {
  rowData = rowData || {}
  const columnRefId = objectPath.get(uischema, 'loadData.columnRefId')
  let id
  if (objectPath.has(rowData, genRefId)) {
    id = objectPath.get(rowData, genRefId)
  } else if (columnRefId && objectPath.has(rowData, columnRefId)) {
    id = objectPath.get(rowData, columnRefId)
  } else if (objectPath.has(rowData, 'id')) {
    id = rowData.id
  } else if (objectPath.has(rowData, 'tableData.id')) {
    id = rowData.tableData.id
  } else {
    id = rowData?.tableData?.no
  }
  return id
}

export const getRowIndex = (arrayData = [], id, uischema) => {
  let tableData = Array.isArray(arrayData) ? arrayData : []
  let index = tableData.findIndex((data) => {
    return getRowId(data, uischema) === id
  })
  return index
}

export const checkWithDefaultValue = (newData, uischema) => {
  const tableColumn = uischema.tableColumn || []
  tableColumn.forEach((column) => {
    if (!column.field || column.typeField === 'multiField') return
    if (objectPath.has(newData, column.field)) {
      let value = objectPath.get(newData, column.field)
      let checkValue = getCheckValue(value, column.typeField)
      objectPath.set(newData, column.field, checkValue)
    } else {
      let value = getDataValue(column, newData)
      objectPath.set(newData, column.field, value)
    }
  })
  return newData
}

export const order = (column, tableRef) => {
  return (a, b) => {
    let orderDirection = tableRef.current.dataManager.orderDirection
    let aField = objectPath.get(a, column.field)
    let bField = objectPath.get(b, column.field)
    if (column.type === 'value' || column.typeField === 'value') {
      if (parseInt(aField) && parseInt(bField)) {
        if (orderDirection === 'asc') {
          return parseInt(aField) > parseInt(bField) ? 1 : -1
        } else if (orderDirection === 'desc') {
          return parseInt(aField) > parseInt(bField) ? 1 : -1
        } else {
          return 0
        }
      } else {
        if (orderDirection === 'asc') {
          return aField.toUpperCase() > bField.toUpperCase() ? 1 : -1
        } else if (orderDirection === 'desc') {
          return aField.toUpperCase() < bField.toUpperCase() ? -1 : 1
        } else {
          return 0
        }
      }
    } else {
      if (orderDirection === 'asc') {
        return aField > bField ? 1 : -1
      } else if (orderDirection === 'desc') {
        return aField < bField ? -1 : 1
      } else {
        return 0
      }
    }
  }
}

export const createSearchParam = (
  searchData,
  { designContext, stateParent },
) => {
  let { jsonForm } = designContext
  const {
    inputSearch: [inputSearch, setInputSearch],
  } = stateParent

  let searchValue = {}
  let search = jsonForm.search
  if (search) {
    let { pathParams = [], queryParams = [] } = search
    pathParams.forEach((path) => {
      let pathName = path?.param || path?.key || path?.value
      let value
      if (path.propType === 'search') {
        pathName = path?.customName || path?.param
        value = objectPath.get(searchData, pathName)
      } else if (path.propType === 'custom') {
        value = path.value
      } else {
        value = objectPath.get(searchData, pathName)
      }
      if (value !== undefined && typeof value !== 'object') {
        objectPath.set(searchValue, pathName, value)
      } else {
        objectPath.set(searchValue, pathName, '')
      }
    })

    queryParams.forEach((query) => {
      let queryName = query?.param || query?.key || query?.value
      let queryKey = query?.key
      let value
      if (query.propType === 'search') {
        queryName = query?.customName || query?.param
        value =
          objectPath.get(searchData, queryName) ||
          objectPath.get(searchData, queryKey)
      } else if (query.propType === 'custom') {
        value = query.value
      } else {
        value = objectPath.get(searchData, queryName)
      }
      if (value !== undefined && typeof value !== 'object') {
        objectPath.set(searchValue, queryName, value)
      } else {
        objectPath.set(searchValue, queryName, '')
      }
    })
  }
  setInputSearch(searchValue)
}
